export default __webpack_public_path__ + "static/media/Goorbagheh.9ab83ad2.png";